import { Amplify } from "aws-amplify";
import { useEffect, useState } from "react";

import { useGetApiAuthConfigs } from "@/services/api";

import {
  buildAuthConfigurations,
  buildTokensStats,
  loadAuthSessionInfo,
  logAuthEvent,
} from "../auth.helper";
import { useAuthContext } from "../auth.hook";

/**
 * Initialize the whole webapp authentication configuration
 *
 * @see https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
 */
export const useAuthInit = () => {
  const { setToken } = useAuthContext();
  const { isSuccess: authConfigRetrieved, authConfigs } =
    useGetApiAuthConfigs();
  const [isOAuthConfigured, setIsOAuthConfigured] = useState(false);
  const [isUserSessionLoaded, setIsUserSessionLoaded] = useState(false);

  useEffect(() => {
    if (authConfigRetrieved && !!authConfigs) {
      logAuthEvent("useInitWebappAuth: api auth configs loaded", authConfigs);
      logAuthEvent("useInitWebappAuth: Amplify.configure");
      Amplify.configure(buildAuthConfigurations(authConfigs));
      setIsOAuthConfigured(true);
    }
  }, [authConfigRetrieved, authConfigs]);

  useEffect(() => {
    if (!isOAuthConfigured) {
      return;
    }

    loadAuthSessionInfo().then((response) => {
      const tokens = response?.tokens;
      logAuthEvent("useInitWebappAuth: completed", buildTokensStats(tokens));
      setToken(tokens?.accessToken);
      setIsUserSessionLoaded(true);
    });
  }, [isOAuthConfigured]);

  return {
    isOAuthConfigured,
    isUserSessionLoaded,
  };
};
